import { Component } from '@angular/core';
import { NgSwitch, NgSwitchDefault, NgSwitchCase } from '@angular/common';
import { environment } from './../environments/environment';
import {  RouterOutlet } from '@angular/router';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarMenuComponent } from "./components/sidebar-menu/sidebar-menu.component";
@Component({
    selector: 'app-root',
    template: `<router-outlet> </router-outlet>`,
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
      RouterOutlet,
      // NavbarComponent,
      // SidebarMenuComponent
    ]
})
export class AppComponent {
  title = 'edutegia-client';
}
